import { render, staticRenderFns } from "./AddAccountSettlementOverlay.vue?vue&type=template&id=c18a0450&"
import script from "./AddAccountSettlementOverlay.vue?vue&type=script&lang=js&"
export * from "./AddAccountSettlementOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports